module.exports = __webpack_public_path__ + "assets/740700302e8409aabc6bf7c4ad3ee471.png";